<script setup>

import {ref} from "vue";
import {useRouter} from "vue-router";
import api from "../../services/api.js";
import ErrorBar from "../../components/global/ErrorBar.vue";

const router = useRouter()

const email = ref('')
const error = ref('')

const submit = async () => {
    error.value = ''
    try {
        await api.getSactumCookie()
        await api.post('auth/forgot-password', {email: email.value})
        await router.push('/auth/reset')
    } catch (e) {
        error.value = 'Something went wrong. Please try again.'
    }
}

</script>

<template>
    <main class="auth">

        <img class="logo" src="/public/internal/images/logo-vertical.png" srcset="/public/internal/images/logo-vertical@2x.png 2x" alt="">

        <form @submit.prevent="submit" class="auth-form">
            <brand-form-input label="Email address." variant="email" v-model="email" />
            <error-bar :error="error" />
            <button type="submit">Reset Password</button>
        </form>
        <router-link class="link-forgot" to="/auth/login">Back to login</router-link>
    </main>
</template>
